import { TFunction } from 'react-i18next'

import {
  IOnboardingCustomJoyrideStep,
  ONBOARDING_JOYRIDE_STEP_TYPE,
} from '../Joyride/OnboardingJoyride/onboardingJoyride.types'

export default (t: TFunction<'translation', undefined>) =>
  [
    {
      type: ONBOARDING_JOYRIDE_STEP_TYPE.TARGET,
      target: '#parking_bay_upload',
      content: t('release.joyride.upload_parking_bay'),
      redirection: {
        origin: '/parking_bay',
      },
      wait: false,
    },
    {
      type: ONBOARDING_JOYRIDE_STEP_TYPE.TARGET,
      target: '#parking_bay_filename_and_date',
      content: t('release.joyride.filename_and_date'),
      wait: false,
    },
    {
      type: ONBOARDING_JOYRIDE_STEP_TYPE.GENERAL,
      content: t('release.joyride.dashboard'),
      wait: false,
    },
  ] as IOnboardingCustomJoyrideStep[]
